import { render, staticRenderFns } from "./SampleGadgetBase.vue?vue&type=template&id=5ac024e8&scoped=true&"
import script from "./SampleGadgetBase.vue?vue&type=script&lang=ts&"
export * from "./SampleGadgetBase.vue?vue&type=script&lang=ts&"
import style0 from "./SampleGadgetBase.vue?vue&type=style&index=0&id=5ac024e8&lang=scss&scoped=true&"
import style1 from "./SampleGadgetBase.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac024e8",
  null
  
)

export default component.exports